import { render, staticRenderFns } from "./ImportDataTab.vue?vue&type=template&id=22a26b2f&"
import script from "./ImportDataTab.vue?vue&type=script&lang=js&"
export * from "./ImportDataTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports